export function PageHeader({ eyebrow, title, subtitle, action }) {
  return (
    <div className="flex items-end justify-between gap-4 pb-6 border-b border-border">
      <div>
        {eyebrow && <p className="eyebrow text-gold mb-2">{eyebrow}</p>}
        <h1 className="font-serif font-light text-3xl sm:text-4xl tracking-tight">{title}</h1>
        {subtitle && <p className="mt-2 text-sm text-muted-foreground max-w-xl leading-relaxed">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
